import VerifyEmailForm from '../components/VerifyEmailForm';

export default function VerifyEmailPage() {
  return <VerifyEmailForm />;
}
